import { RightFloatingButtonScalor } from "../../editor_common_components";
import { Button } from "../../../core/components/button";
import { Dialog, DialogProps } from "../../../core/components/dialog";
import { TextBox, TextBoxField } from "../../../core/components/textBox";
import { FAIcon } from "../../../core/components/faIcon";
import React from "react";
export class UniqueQuestionNamePicker extends React.Component<{ onTextChange: any, value: string, label: string, customProps: { usedUniqueNames: string[] } }, { showDialog: boolean }>{
    constructor(props) {
        super(props);
        this.state = { showDialog: false };
    }

    handleFieldClicked = (field: { model: string }, value: any, dataItem?: any) => {
        this.props.onTextChange(value);
    }

    handleObjectChanged = (field: { model: string }, object: any) => {
        this.props.onTextChange(object.Id);
    }

    handleSave = (name) => {
        this.setState({ showDialog: false });
        this.props.onTextChange(name);
    }

    render() {
        const dialog = this.state.showDialog ? <UniqueQuestionNameEditor value={this.props.value}
            onClose={() => this.setState({ showDialog: false })}
            onSave={this.handleSave}
            usedIds={this.props.customProps.usedUniqueNames}></UniqueQuestionNameEditor> : null;
        return (
            <li>
                {dialog}
                <div title={this.props.label}>
                    <span className="property-name">
                        <RightFloatingButtonScalor>
                            <Button iconName="edit" title="Edit" handleClick={() => this.setState({ showDialog: true })}></Button>
                        </RightFloatingButtonScalor>
                        {this.props.label}
                    </span>
                    <div className="c" style={{ "whiteSpace": "nowrap" }}>
                        {this.props.value}
                    </div>
                </div>
            </li>
        );
    }
};

export class UniqueQuestionNameEditor extends React.Component<{ onSave, onClose, value, usedIds: string[] }, { currentValue }>{

    private textArea: HTMLTextAreaElement;

    private dialogProps: DialogProps = {
        title: "Change unique question name ",
        actions: [
            {
                label: "Cancel",
                action: () => {
                    this.props.onClose();
                    return true;
                }
            },
            {
                label: "Save",
                action: () => {
                    this.props.onSave(this.isValid(this.state.currentValue) ? this.state.currentValue : this.initialValue)
                },
                primary: true
            }],
        afterClose: () => {
        },
        width: 500,
        open: true
    }

    private textBoxProps: TextBoxField = {
        type: "text",
        model: "",
        triggerOnChange: true
    }
    private initialValue;
    constructor(props) {
        super(props)
        this.initialValue = props.value;
        this.state = { currentValue: props.value };
    }

    handleChange = (field, value: string) => {
        if (value.includes('.')) {
            return;
        }
        this.setState({ currentValue: value.toUpperCase() });
    }

    isValid = (newValue) => {
        if (this.props.usedIds) {
            for (var id of this.props.usedIds) {
                if (id != this.initialValue && id == newValue) {
                    return false;
                }
            }
        }
        return true;
    }

    getInvalidIndicator = () => {
        return !this.isValid(this.state.currentValue) ? <div style={{
            marginTop: "5px",
            backgroundColor: "#f8e8e8",
            borderLeftColor: "red",
            borderLeftWidth: "4px",
            padding: "3px", borderLeftStyle: "solid",
            color: "#f05050",
            display: "flex"
        }}> <FAIcon name="exclamation-triangle" sameWidth={true} /><div style={{ marginLeft: "5px" }}>This name is allready in use. Please enter an unique identifier</div></div>
            : null;
    }

    render() {
        const invalidIndicator = this.getInvalidIndicator();

        return (<Dialog {...this.dialogProps}>
            <TextBox field={this.textBoxProps} value={this.state.currentValue}
                onChange={this.handleChange}
                disabled={false} required={true} />
            {invalidIndicator}
        </Dialog>

        );
    }
};